import {
  OpportunitiesPipelinesStatusesListData,
  opportunitiesPipelinesStatusesListInfiniteOptions,
  PaginatedReturnOpportunityStatusListReadable,
  ReturnOpportunityStatusReadable
} from '@crm/api'
import { InfiniteSelect } from '@crm/components'
import { FormColorPicker } from '@shared/components'
import { useLocales } from '@shared/locales'
import { Checkbox, Form, Input } from 'antd'

type Props = {
  pipelineId: number
}

export const FormNomenclaturesOpportunitiesPipelinesStatutes = ({
  pipelineId
}: Props) => {
  const { t } = useLocales()

  return (
    <>
      <Form.Item
        name="name"
        label={t('nomenclature.name')}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="code"
        label={t('nomenclature.code')}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <FormColorPicker
        itemProps={{
          label: t('nomenclature.color')
        }}
        showText
      />

      <Form.Item
        name="order"
        label={t('nomenclature.order')}
        rules={[{ required: true }]}
      >
        <Input type="number" />
      </Form.Item>

      <Form.Item
        name="allowed_transition_statuses"
        label={t('nomenclature.allowed_transition_status_codes')}
        tooltip={t('nomenclature.allowed_transition_status_codes_hint')}
      >
        <InfiniteSelect<
          OpportunitiesPipelinesStatusesListData,
          PaginatedReturnOpportunityStatusListReadable,
          ReturnOpportunityStatusReadable
        >
          mode="multiple"
          popupMatchSelectWidth
          placeholder={t('main.select')}
          getQueryFunction={opportunitiesPipelinesStatusesListInfiniteOptions}
          baseOptions={{ path: { pipeline_id: pipelineId } }}
          getOptions={({ options }) =>
            options.map(({ id, name }) => ({ value: id, label: name }))
          }
        />
      </Form.Item>

      <Form.Item
        name="requires_refusal_reason"
        label={t('nomenclature.requires_refusal_reason')}
        valuePropName="checked"
        initialValue={false}
      >
        <Checkbox />
      </Form.Item>

      <Form.Item
        name="is_default"
        label={t('nomenclature.is_default')}
        valuePropName="checked"
        initialValue={false}
      >
        <Checkbox />
      </Form.Item>
    </>
  )
}
